// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownDependentFormController from "./dropdown_dependent_form_controller"
application.register("dropdown-dependent-form", DropdownDependentFormController)

import FilterComponentController from "./filter_component_controller"
application.register("filter-component", FilterComponentController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterVisibilityController from "./filter_visibility_controller"
application.register("filter-visibility", FilterVisibilityController)

import HideConnectivitySettingsController from "./hide_connectivity_settings_controller"
application.register("hide-connectivity-settings", HideConnectivitySettingsController)

import LoginI18nController from "./login_i18n_controller"
application.register("login-i18n", LoginI18nController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)
